import React from 'react';
import styled, { css } from 'styled-components';
import BasicModalHeaderV2 from '@/app/components/search/components/Modal/LayoutElements/BasicModalHeaderV2';
import { useOverlayContext } from '@/app/common/context/OverlayContext.ts';
import { focusClearsStickyFooter } from '@/app/common/hooks/useScrollShadows.ts';

export const PopoverWrapper = styled.div<{
  $visible: boolean;
  $padding: string;
  $borderRadius: string;
  $maxWidth: string;
  $maxHeight?: string;
  $width?: string;
  $inline?: boolean;
  $boxShadow?: string;
}>`
  position: ${({ $inline }) => ($inline ? 'absolute' : 'fixed')};
  z-index: ${({ $inline }) => ($inline ? 10 : 1300)};
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overscroll-behavior: none;
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  box-shadow: ${({ $boxShadow, theme }) => $boxShadow ?? theme.kallisto.shadow.mediumDownShadow};
  padding: ${({ $padding }) => $padding};
  ${({ $width }) => $width && `width: ${$width};`}
  max-width: ${({ $maxWidth }) => $maxWidth};
  ${({ $maxHeight }) => $maxHeight && `max-height: ${$maxHeight};`}
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s ease;
  ${focusClearsStickyFooter}
`;

const PopoverStickyHeaderBase = styled(BasicModalHeaderV2)`
  position: sticky;
  top: 0;
  z-index: 1;
  flex-shrink: 0;
`;

export const PopoverStickyHeader = (props: React.ComponentProps<typeof BasicModalHeaderV2>) => {
  const { headerShadow } = useOverlayContext();
  return <PopoverStickyHeaderBase align="left" showShadow={headerShadow} {...props} />;
};

export const PopoverFooterShadow = styled.div<{ $showShadow?: boolean }>`
  position: sticky;
  bottom: 0;
  height: 0;
  flex-shrink: 0;
  pointer-events: none;

  ${({ $showShadow }) =>
    $showShadow &&
    css`
      box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumTopShadow};
    `}
`;

export const PopoverBody = styled.div<{ $padding: string }>`
  padding: ${({ $padding }) => $padding};
`;
